import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import { Root } from '../Views';
import { ConfirmationHicas } from '~/Views/Hicas/ConfirmationHicas';
import { PasswordResetHicas } from '~/Views/Hicas/ResetPasswordHicas';
import { Unauthorized } from '~/Views/Unauthorized/Unauthorized';
import { Callback } from '~/Views/Callback';
import { BootstrapSystem } from '~/Components/Bootstrap/Bootstrap';

export const App = () => (
  <BootstrapSystem>
    <ConfigProvider prefixCls="ant">
      <BrowserRouter basename="/">
        <Switch>
          <Route exact path="/confirmemail" component={ConfirmationHicas} />
          <Route exact path="/passwordreset" component={PasswordResetHicas} />
          <Route exact path="/unauthorized" component={Unauthorized} />
          {/* Callback từ /connect/authorize (Authorization Code + PKCE). */}
          <Route exact path="/callback" component={Callback} />
          <Route path="/" component={Root} />
        </Switch>
      </BrowserRouter>
    </ConfigProvider>
  </BootstrapSystem>
);
